import React from 'react';
import { Container, Row, Col, Onglet, OngletItem } from '@design-system-etat/dsfr-react';
import { useSelector } from 'react-redux';
import Armes from './armes';
import Munitions from './munitions';
import RepriseDeDonneesArme from './armes/components/repriseDeDonnees/index';
import { ROLE_TIREUR_SPORTIF } from '../../../utils/droitsEtRoles.constant';
import verifierDroits from '../../../components/VerifierDroits/verifierDroits.func';

const OngletCustom = (verifDroitTireurSportif) => {
    let onglets = [];

    onglets = [
        {
            titre: 'Mes armes',
            onglet: <Armes />,
        },
    ];

    if (verifDroitTireurSportif.verifDroit) {
        onglets.push({
            titre: 'Mes munitions',
            onglet: <Munitions />,
        });
    }

    return (
        <Onglet nomSystemeOnglet="choix du materiel" id="armes">
            {onglets.map((onglet) => {
                return <OngletItem titre={onglet.titre}>{onglet.onglet}</OngletItem>;
            })}
        </Onglet>
    );
};

const Ratelier = () => {
    const { data: dataProfil } = useSelector((state) => state.profil.usager);

    return (
        <Container margeExterne={false}>
            <Row goutierre>
                <Col>
                    <h1>Mon râtelier numérique</h1>
                </Col>
            </Row>
            <RepriseDeDonneesArme />
            <OngletCustom verifDroit={verifierDroits(dataProfil, [ROLE_TIREUR_SPORTIF])} />
        </Container>
    );
};

export default Ratelier;
